import React from "react";
import ContentLoader from "react-content-loader";


const SkeletonSupplies = (props) => (
  <ContentLoader
    speed={2}
    width={props.width}
    height={344}
    // viewBox="0 0 1290 344"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
    
  >
    <rect x="0" y="0" rx="0" ry="0" width="537" height="42" />

    {/* <rect x="0" y="75" rx="0" ry="0" width="1290" height="1" />
    <rect x="1287" y="75" rx="1" ry="1" width="1" height="238" />
    <rect x="0" y="75" rx="1" ry="1" width="1" height="238" />
    <rect x="0" y="308" rx="0" ry="0" width="1290" height="1" /> */}

    <rect x="41" y="72" rx="0" ry="0" width="100" height="155" />
    <rect x="169" y="77" rx="0" ry="0" width="1200" height="40" />
    <rect x="169" y="132" rx="0" ry="0" width="1200" height="40" />
    <rect x="169" y="187" rx="0" ry="0" width="1200" height="40" />

    {/* <rect x="169" y="107" rx="0" ry="0" width="257" height="19" />
    <rect x="169" y="132" rx="0" ry="0" width="111" height="14" />
    <rect x="169" y="161" rx="0" ry="0" width="404" height="56" />
    <rect x="169" y="228" rx="0" ry="0" width="144" height="46" /> */}


    {/* <rect x="643" y="102" rx="0" ry="0" width="582" height="45" />
    <rect x="653" y="170" rx="0" ry="0" width="150" height="18" />
    <rect x="853" y="170" rx="0" ry="0" width="150" height="18" />
    <rect x="1053" y="170" rx="0" ry="0" width="150" height="18" /> */}

  </ContentLoader>
);

export default SkeletonSupplies;
